export const getClarificationFromPayload = (payload: any) => {
  if (payload?.clarification?.questions?.length) {
    return payload.clarification;
  }
  if (Array.isArray(payload?.currentTurnMessages)) {
    for (let i = payload.currentTurnMessages.length - 1; i >= 0; i -= 1) {
      const item = payload.currentTurnMessages[i];
      if (item?.clarification?.questions?.length) {
        return item.clarification;
      }
    }
  }
  if (Array.isArray(payload?.history)) {
    for (let i = payload.history.length - 1; i >= 0; i -= 1) {
      const item = payload.history[i];
      if (item?.clarification?.questions?.length) {
        return item.clarification;
      }
    }
  }
  return undefined;
};
